import { render, staticRenderFns } from "./FacebookLoginBtn.vue?vue&type=template&id=3b3fe2c6&"
import script from "./FacebookLoginBtn.vue?vue&type=script&lang=js&"
export * from "./FacebookLoginBtn.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLoginBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports